import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constants } from 'src/app/shared/common/contants';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { ExceljsServiceService } from 'src/app/shared/services/exceljs-service.service';
export interface createAttributesPopupEditData {
  existingAttributesData:any;
}
@Component({
    selector: 'app-create-attributes-screen',
    templateUrl: './create-attributes-screen.component.html',
    styleUrls: ['./create-attributes-screen.component.scss'],
    standalone: false
})
export class CreateAttributesScreenComponent implements OnInit {
validations_form: UntypedFormGroup;
validation_messages
columnDefs;
rowClassRules;
defaultColDef;
rowSelectionForTablesFields;
rowSelection;

paginationPageSize;

paginationNumberFormatter;

lastpage;

currentpage;

nextpage;

nextpageplusone;

totalpages;

buttonIdList: any = [];
pagesize;
components: any;
gridApi;
  buttonColor = "";
  backgroundColorScreen;
  attributesDataList:any=[]

  attributeObject={
    "index":"",
    "name": null, 
    "type": null, 
    "label": null, 
    "required": false, 
    "type_value": null, 
    "list_column": false, 
    "max_type_value": null, 
    "min_type_value": null, 
    "isControlledVocabulary": null
  }
  onEditButton=false;
  existingDataList=[]
  attributeHeaders=["name","label","type","required", "type_value", "list_column", "max_type_value", 
      "min_type_value", "isControlledVocabulary"]
  attributeTypeData=["Autonumber","Boolean","Component","Date","DateTime","ExactMatchString",
    "ID","LongText","Lookup","Number","Object","ObjectReference","Picklist","RichText","String","URL"]
  constructor(
    private validation: validationmethod,
        private localStorageSettings: LocalStorageSettingsService,
        public dialogref: MatDialogRef<CreateAttributesScreenComponent>,
        @Inject(MAT_DIALOG_DATA) public data:createAttributesPopupEditData,
        private snackbar: MatSnackBar,private constants: constants,
        private msg: ErrorMessages,private exceljsService: ExceljsServiceService
  ) { 
    this.validation_messages = this.msg.createAttributes;
     this.components = {
          buttonRenderer: Actionbutton,
        }
  }

  ngOnInit(): void {
    if(this.data.existingAttributesData){
      console.log(this.data.existingAttributesData);
      this.existingDataList=JSON.parse(this.data.existingAttributesData);
      for(let i=0;i<this.existingDataList.length;i++){
        this.existingDataList[i].index=i
      }
      this.attributesDataList= this.existingDataList
    }
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        edit: this.EditIcon.bind(this),
        delete: this.deleteIcon.bind(this),
      }, width: 150
    },
      { headerName: 'Name', headerTooltip: 'Name', tooltipValueGetter: (params) => 'Name : ' + params.value, field: 'name', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Label', headerTooltip: 'Label', tooltipValueGetter: (params) => 'Label : ' + params.value, field: 'label', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Type', headerTooltip: 'Type', tooltipValueGetter: (params) => 'Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Type Value', headerTooltip: 'Type Value', tooltipValueGetter: (params) => 'Type Value : ' + params.value, field: 'type_value', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Max Type Value', headerTooltip: 'Max Type Value', tooltipValueGetter: (params) => 'Max Type Value : ' + params.value, field: 'max_type_value', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Min Type Value', headerTooltip: 'Min Type Value', tooltipValueGetter: (params) => 'Min Type Value : ' + params.value, field: 'min_type_value', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Required', headerTooltip: 'Required', tooltipValueGetter: (params) => 'Required : ' + params.value, field: 'required', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'List Column', headerTooltip: 'List Column', tooltipValueGetter: (params) => 'List Column : ' + params.value, field: 'list_column', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Is Controlled Vocabulary', headerTooltip: 'Is Controlled Vocabulary', tooltipValueGetter: (params) => 'Is Controlled Vocabulary : ' + params.value, field: 'isControlledVocabulary', filter: 'agTextColumnFilter', width: 150 }
      
    ],
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    this.formValidation()
  }

  formValidation() {
      
      this.validations_form = new UntypedFormGroup({
  
        attributeName: new UntypedFormControl('', [Validators.required,Validators.maxLength(100)]),
        attributeLabel: new UntypedFormControl('', [Validators.required,Validators.maxLength(100)]),
        attributeType:new UntypedFormControl(''),
        attributetype_value:new UntypedFormControl(''),
        attributeMax_type_value:new UntypedFormControl(''),
        attributeMin_type_value:new UntypedFormControl(''),
        // keyOrder:new UntypedFormControl('', [Validators.required]),
        isAttributeRequired:new UntypedFormControl(''),
        attributeListColumn:new UntypedFormControl(''),
        isControlledVocabulary:new UntypedFormControl('')
      });
    }
  onBtExport() {
    this.gridApi.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }
  saveAttributes(){
    let attributesData = this.attributesDataList;

    // Just remove index, no modification
    let attributesJsonData = attributesData.map(({ index, ...rest }) => rest);
    
    let attributesStringData = JSON.stringify(attributesJsonData);
    console.log(attributesStringData);
    this.dialogref.close(attributesStringData);
  }
  cancel(){
    this.dialogref.close();
  }
  editAttribute(data,index){

  }
  deleteWhere(index){

  }
  EditIcon(e){
  console.log(e);
    this.attributeObject={
      index:e.rowData.index,
      name: e.rowData.name, 
      type: e.rowData.type, 
      label: e.rowData.label, 
      required: e.rowData.required, 
      type_value: e.rowData.type_value, 
      list_column: e.rowData.list_column, 
      max_type_value: e.rowData.max_type_value, 
      min_type_value: e.rowData.min_type_value, 
      isControlledVocabulary: e.rowData.isControlledVocabulary 
    }
    this.onEditButton=true
  }
  deleteIcon(e){
  console.log(e);
  this.attributesDataList.splice(e.rowData.index, 1);
  for(let i=0;i<this.attributesDataList.length;i++){
    this.attributesDataList[i].index=i
  }
  this.gridApi.api.setGridOption('rowData', this.attributesDataList)
  }
  onGridReady(params){
    this.gridApi = params;
    //this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
    params.api.setGridOption('rowData', [])
    this.gridApi.api.setGridOption('rowData', this.attributesDataList)
  }
  addWhere(){
    console.log(this.attributeObject);
    
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
      const duplicate = this.attributesDataList.some(item =>
        item.label ==this.attributeObject.label &&
        item.name == this.attributeObject.name 
      
      )
      console.log(duplicate)
      if(duplicate){
        console.log("Inside duplicate")
        this.snackbar.open("Attribute already existed","Ok",{duration:5000})
        return
      }
      if(this.onEditButton){
        
        this.attributesDataList[this.attributeObject.index]=this.attributeObject
        this.gridApi.api.setGridOption('rowData', this.attributesDataList)
      }else{
        this.attributeObject.index=this.attributesDataList.length
        this.attributesDataList.push(this.attributeObject)
        this.gridApi.api.setGridOption('rowData', this.attributesDataList)
      }
      
      this.attributeObject={
        "index":"",
        "name": null, 
        "type": null, 
        "label": null, 
        "required": false, 
        "type_value": null, 
        "list_column": false, 
        "max_type_value": null, 
        "min_type_value": null, 
        "isControlledVocabulary": null
      }
      this.onEditButton=false;
      this.validations_form.reset();
      this.formValidation();
      this.validations_form.clearValidators();
    }
  }
   async onFileChange(event: any): Promise<void> {
      console.log(event);
      let input = event.target as HTMLInputElement;
      const target: DataTransfer = <DataTransfer>event.target;
      
      if (target.files.length !== 1) {
        console.error('Cannot use multiple files');
        return;
      }
  
  //     const reader: FileReader = new FileReader();
  //     reader.onload = (e: any) => {
  //       const binaryData = e.target.result;
  //       const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
  
  //       // Read the first sheet
  //       const sheetName: string = workbook.SheetNames[0];
  //       const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
  
  //       // Convert to JSON
  //       const jsonData:any = XLSX.utils.sheet_to_json(sheet, { header: 1 });
  // console.log(jsonData);
  
  //       if (jsonData.length > 0) {
  //         let headerList=[]
  //         headerList=jsonData[0]
  //         let labelsToRemove = this.attributeHeaders.map(obj => obj);
  //         headerList =  jsonData[0].filter(item => !labelsToRemove.includes(item));
  //         if(headerList.length == 0){
  //           let data = jsonData.slice(1).map((row: any[], i: number) => {
  //             const rowObj: any = { index: this.attributesDataList.length + i }; // Starts from 0
  //             jsonData[0].forEach((key: string, index: number) => {
  //               rowObj[key] = row[index] !== undefined ? row[index] : '';
  //             });
  //             return rowObj;
  //           });
  //           console.log(data);
  //           try {
  //             this.validateExcelData(data);
  //              const uniqueData = data.filter((item,index,self) =>
  //               index === self.findIndex(record=>
  //                 record.name?.trim()===item.name?.trim() && record.label?.trim()===item.label?.trim()
  //               )
  //             )
  //             console.log(uniqueData)
  //             const finalUniqueData = uniqueData.filter(newRecord =>
  //               !this.attributesDataList.some(existingRecord =>
  //                 existingRecord.name?.trim() === newRecord.name?.trim() && existingRecord.label?.trim() === newRecord.label?.trim()
  //               )
  //             )
  //              this.attributesDataList.push(...finalUniqueData)
  //             //  this.attributesDataList.push(...data)
  //              this.gridApi.api.setGridOption('rowData', this.attributesDataList)
  //           } catch (error) {
  //             console.error(error.message);
  //             // optionally show error in UI
  //             this.snackbar.open(error.message, "OK", { duration: 5000 });
  //           }
           
  //         }else{
  //           alert("The headers appear to be mismatched. Kindly update them to match correctly.")
  //     }
  //       }
  //     };
     
  //     reader.readAsBinaryString(target.files[0]);
      try {

  const jsonData =
    await this.exceljsService.readExcelAsMatrix(
      target.files[0]
    );

  console.log(jsonData);

  if (jsonData.length > 0) {

    let headerList: any[] = [];

    headerList = jsonData[0];

    const labelsToRemove =
      this.attributeHeaders.map(obj => obj);

    headerList =
      jsonData[0].filter(
        item => !labelsToRemove.includes(item)
      );

    if (headerList.length === 0) {

      const data = jsonData
        .slice(1)
        .map((row: any[], i: number) => {

          const rowObj: any = {
            index: this.attributesDataList.length + i
          };

          jsonData[0].forEach(
            (key: string, index: number) => {

              rowObj[key] =
                row[index] !== undefined
                  ? row[index]
                  : '';

            }
          );

          return rowObj;

        });

      console.log(data);

      try {

        this.validateExcelData(data);

        const uniqueData =
          data.filter(
            (item, index, self) =>
              index === self.findIndex(
                record =>
                  record.name?.trim() === item.name?.trim() &&
                  record.label?.trim() === item.label?.trim()
              )
          );

        const finalUniqueData =
          uniqueData.filter(
            newRecord =>
              !this.attributesDataList.some(
                existingRecord =>
                  existingRecord.name?.trim() === newRecord.name?.trim() &&
                  existingRecord.label?.trim() === newRecord.label?.trim()
              )
          );

        this.attributesDataList.push(
          ...finalUniqueData
        );

        this.gridApi.api.setGridOption(
          'rowData',
          this.attributesDataList
        );

      } catch (error: any) {

        console.error(error.message);

        this.snackbar.open(
          error.message,
          "OK",
          { duration: 5000 }
        );

      }

    } else {

      alert(
        "The headers appear to be mismatched. Kindly update them to match correctly."
      );

    }

  }

} catch (error) {

  console.error(error);

  this.snackbar.open(
    "Unable to read Excel file",
    "OK",
    { duration: 5000 }
  );

}
      input.value = '';
    }

    validateExcelData(data: any[]): void {
      data.forEach((item, i) => {
        if (!item.name || !item.label) {
          throw new Error(`Name and Label are required fields. Some rows in the uploaded file are missing them.`);
        }
      });
    }
     downloadTemplate() {
			  /*
        @modified by Aman Singh
        @date 16-05-2024
        @desc the file name from "CasesForSplitReports.csv" to "ReferenceKeysForSplitReport.csv" and column "CASE NUMBER" to "SOURCE_REFERENCE_KEY"
       */

    console.log('working');
    var data = [{
      "name":'',
      "label":'',
      "type":'', 
      "required":'',
       "type_value":'',
        "list_column":'',
         "max_type_value":'', 
      "min_type_value":'',
       "isControlledVocabulary":''
    }];
    this.JSONToCSVConvertor(data, 'AttributeHeadersTemplate', true);
  }

  JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = '';

      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {

        //Now convert each value to string and comma-seprated
        row += index + ',';
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = '';

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }
      //add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert('Invalid data');
      return;
    }

    //Generate a file name
    var fileName = '';
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_');

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement('a');
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    // @ts-ignore
    link.style = 'visibility:hidden';
    link.download = fileName + '.csv';

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
